import axios from 'axios';
import { PaginationInfo, RequestParams } from 'types/pagination';
import { CollectionFile, TypeItem } from 'types/question';
import { ContainerObject } from 'types/container';
import { Assignment, AssignmentFilter, AssignmentList, AssignmentType } from 'types/assignment';

export const getAssignments = async (
    setAssignments: (val: Assignment[]) => void,
    requestParams: RequestParams,
    setPaginationInfo?: (val: PaginationInfo) => void
) => {
    try {
        const params: any = {
            page: requestParams.page,
            per_page: requestParams.per_page,
            sort: `${requestParams.sort[0].sort === 'desc' ? '-' : ''}${requestParams.sort[0].field}`
        };
        requestParams.filters?.forEach((filter) => {
            params[`filter[${filter.name}]`] = filter.value;
        });
        const response = await axios.get(`/assignments`, { params });
        const assignmentData: Assignment[] = [];
        response.data.assignments.data.forEach((item: Assignment) => {
            assignmentData.push(item);
        });

        let availableFilters: any = [];
        response.data.assignments.filters.forEach((filter: any) => {
            availableFilters = [...availableFilters, ...filter.items.options];
        });

        setPaginationInfo?.({
            total: response.data.assignments.total,
            last_page: response.data.assignments.last_page,
            per_page: response.data.assignments.per_page,
            sortable_fields: availableFilters.map((a: any) => a.name),
            available_filters: response.data.assignments.filters
        });
        setAssignments(assignmentData);
    } catch (err) {
        console.error(`error in getting assignments ${err}`);
    }
};

export const createAssignment = async (
    assignment: Assignment,
    clone: boolean,
    onSuccess: (val: boolean) => void,
    ongetStatusCode: (val: any) => void
) => {
    const formData = new FormData();

    if (assignment.file) {
        const fileData = assignment.file as CollectionFile;
        if (fileData?.upload_data) {
            formData.append(
                fileData.file_path
                    .replace(/[^/.]+$/, '')
                    .replace(/\s+/g, '')
                    .replace(/(\.)/g, ''),
                fileData.upload_data
            );
            assignment.file.file_path = fileData.file_path
                .replace(/[^/.]+$/, '')
                .replace(/\s+/g, '')
                .replace(/(\.)/g, '');
        }
    }

    for (const [key, value] of Object.entries(assignment)) {
        if (value !== null) {
            if (['file', 'objects', 'tags'].includes(key)) {
                formData.append(key, JSON.stringify(value));
            } else {
                formData.append(key, value);
            }
        }
    }

    if (clone) {
        formData.append('clone', '1');
    }

    try {
        await axios.post('/assignments', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        onSuccess(true);
    } catch (err: any) {
        console.error(`error in create assignment ${err}`);
        ongetStatusCode(err.response.status);
        onSuccess(false);
    }
};

export const getAssignment = async (
    id: string,
    setAssignment: (val: Assignment) => void,
    setObjects?: (val: ContainerObject[]) => void
) => {
    try {
        const response = await axios.get(`/assignments/${id}`);
        const assignment = response.data.assignment as Assignment;
        setAssignment(assignment);
        if (setObjects) {
            const sortedObjects = response.data.assignment.objects.sort(
                (a: ContainerObject, b: ContainerObject) => a.priority - b.priority
            );
            setObjects(sortedObjects);
        }
    } catch (err) {
        console.error(`error in getting assignment ${err}`);
    }
};

export const updateAssignment = async (assignment: Assignment, onSuccess: (val: boolean) => void, ongetStatusCode: (val: any) => void) => {
    const formData = new FormData();

    if (assignment.file) {
        const fileData = assignment.file as CollectionFile;
        if (fileData?.upload_data) {
            formData.append(
                fileData.file_path
                    .replace(/[^/.]+$/, '')
                    .replace(/\s+/g, '')
                    .replace(/(\.)/g, ''),
                fileData.upload_data
            );
            assignment.file.file_path = fileData.file_path
                .replace(/[^/.]+$/, '')
                .replace(/\s+/g, '')
                .replace(/(\.)/g, '');
        }
    }

    for (const [key, value] of Object.entries(assignment)) {
        if (value !== null) {
            if (['file', 'objects', 'tags'].includes(key)) {
                formData.append(key, JSON.stringify(value));
            } else {
                formData.append(key, value);
            }
        }
    }

    formData.append('_method', 'PUT');

    try {
        await axios.post(`/assignments/${assignment.id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        onSuccess(true);
    } catch (err: any) {
        console.error(`error in update assignment ${err}`);
        ongetStatusCode(err.response.status);
        onSuccess(false);
    }
};

export const disableAssignment = async (id: string) => {
    try {
        await axios.delete(`/assignments/${id}`);
    } catch (err) {
        console.error(`error in disable assignment ${err}`);
    }
};

export const getAssignmentTypes = async (setAssignmentTypes: (value: TypeItem[]) => void) => {
    try {
        const response = await axios.get('/assignment/types');
        setAssignmentTypes(response.data.types);
    } catch (err) {
        console.error(`Error getting assignment types list ${err}`);
    }
};
export const getAssignmentList = async (setAssignmentList: (val: AssignmentList[]) => void, product_category_id?: number) => {
    try {
        if (product_category_id) {
            const response = await axios.get(`/get-assignment-list?product_category_id=${product_category_id}`);
            setAssignmentList(response.data.data);
        } else {
            const response = await axios.get(`/get-assignment-list`);
            setAssignmentList(response.data.data);
        }
    } catch (error) {
        console.error(`error in create assignment ${error}`);
    }
};
export const getAssignmentType = async (setAssignmentType: (val: AssignmentType[]) => void, product_category_id?: number) => {
    try {
        if (product_category_id) {
            const response = await axios.get(`/get-assignment-list?type=exam&product_category_id=${product_category_id}`);
            setAssignmentType(response.data.data);
        } else {
            const response = await axios.get(`/get-assignment-list?type=exam`);
            setAssignmentType(response.data.data);
        }
    } catch (error) {
        console.error(`error in create assignment ${error}`);
    }
};
export const getAssignmentFilter = async (setAssignmentFilter: (val: AssignmentFilter[]) => void, product_category_id?: number) => {
    try {
        if (product_category_id) {
            const response = await axios.get(`/get-assignment-list?type=exam&product_category_id=${product_category_id}`);
            setAssignmentFilter(response.data.data);
        } else {
            const response = await axios.get(`/get-assignment-list?type=exam`);
            setAssignmentFilter(response.data.data);
        }
    } catch (error) {
        console.error(`error in create assignment ${error}`);
    }
};

export const getAssignmentSorting = async (name: String, setAssignmentFilter: (val: AssignmentFilter[]) => void) => {
    try {
        const response = await axios.get(`/get-assignment-list?type=exam&sort=${name}`);
        setAssignmentFilter(response.data.data);
    } catch (error) {
        console.error(`error in create assignment ${error}`);
    }
};
export default getAssignments;
